import { useState } from 'react';
import { Link } from 'react-router-dom';
import { type NewsItem, formatDate, getImageUrl } from '@/lib/newsHelpers';

type Props = {
  item: NewsItem;
  index?: number;
  headingLevel?: 'h2' | 'h3';
  preview?: boolean;
};

export function NewsCard({ item, index = 0, headingLevel: Heading = 'h2', preview = false }: Props) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const candidate = getImageUrl(item);
  const imageUrl = candidate === failedUrl ? null : candidate;
  const gradients = ['from-primary to-secondary', 'from-secondary to-accent', 'from-accent to-primary'];
  const className = 'group bg-card rounded-panel overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border focus:outline-none focus:ring-2 focus:ring-primary text-left block';
  const content = (
    <article>
      <div className={`h-48 relative ${imageUrl ? 'bg-muted' : `bg-gradient-to-br ${gradients[index % 3]}`}`}>
        {imageUrl && <img src={imageUrl} alt={item.cover_alt?.trim() || item.title} className="w-full h-full object-cover" loading="lazy" onError={() => setFailedUrl(imageUrl)} />}
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <time className="text-xs text-muted-foreground" dateTime={item.date}>{item.date && formatDate(item.date)}</time>
          <span className="text-xs font-semibold bg-secondary text-secondary-foreground px-2 py-0.5 rounded-full">{item.tag}</span>
        </div>
        <Heading className="font-heading font-bold text-lg mb-2 line-clamp-2 group-hover:text-primary transition-colors">{item.title}</Heading>
        <p className="text-sm text-muted-foreground line-clamp-3">{item.excerpt}</p>
        <p className="text-sm font-semibold text-primary mt-3 group-hover:underline">Czytaj więcej →</p>
      </div>
    </article>
  );
  return preview ? <div className={className}>{content}</div> : <Link to={`/aktualnosci/${item.slug}`} className={className}>{content}</Link>;
}